module.exports = __webpack_public_path__ + "cd455783/img/mini-logo.18817ee5.svg";